import { createStore } from "vuex";
import tokenService from "../services/token.service";
import { getBreadcrumbsQuery } from "@/graphs/breadcrumbsGraph";
import { getToastErrorQuery } from "@/graphs/toastMsgGraph";
// // import utils from "@/utils/utils";
import { $axios } from "../axios/axios-config";
import utils from '@/utils/utils'


const store = createStore({
  state: {
    user: {
      UserRoles: null,
      UserName: null,
      UserId: null,
      Name:"",
      ImageUrl:null,
    },
    isLoading: false,
    breadCrumb: null,
    notFoundToast:null,
  },
  getters: {
    getUser: (state) => state.user,
  },

  actions: {
    async getLoggedUser({ commit }) {
      await $axios
        .get(`/api/Auth/user-details`)
        .then((response) => {
          if (response.status == 200) {
            commit("SET_USERS", response.data);
          }
        })
        .catch(() => {
        });
    },
    async fetchBreadcrumbs({ state, commit }) {
      const lang = utils.getCookie()
      const query = getBreadcrumbsQuery(lang)
      const response = await $axios.post('/api/Squidex/postGraphQLAsync', query)
      let cleanData = utils.removeLocaleDeep(response, lang)
      commit('SET_BREADCRUMB', cleanData.data?.data?.findBreadcrumbsSingleton?.data)
    },
    async fetchToastMsg({ state, commit }) {
      const lang = utils.getCookie()
      const query = getToastErrorQuery(lang)
      const response = await $axios.post('/api/Squidex/postGraphQLAsync', query)
      let cleanData = utils.removeLocaleDeep(response, lang)
      commit('SET_TOAST_MSG', cleanData.data?.data?.findToastErrorSingleton?.data?.textError)
    },
    removeLoggedUser({ commit }) {
      commit("SET_USERS", {
        UserRole: null,
        UserName: null,
        UserId: null,
      },);
    },
  },
  mutations: {
    SET_LOADER(state, value) {
      state.isLoading = value;
    },
    TOGGLE_LOADER(state) {
      state.isLoading = !state.isLoading;
    },
    SET_USERS(state, user) {
      state.user = user;
    },
    SET_BREADCRUMB(state, data) {
      state.breadCrumb = data
    },
    SET_TOAST_MSG(state, data) {
      state.notFoundToast = data
    },
    
  },
});

export default store;